import Sidebar from './Sidebar';
import AppBar from './Appbar';
import { useSelector } from 'react-redux';
import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';
import { useGlobalDarkMode } from 'hooks/useDarkMode';

const WrapperComponent = ({ children }) => {
  const sideBarState = useSelector((state) => state.sidebar.sideBarState);
  // const { currentUser } = useSelector((state) => state.user);
  const currentUser = JSON.parse(localStorage.getItem("user"))
  const location = useLocation();
  const isDarkModeActive = useGlobalDarkMode();
  
  // Check if we're on stencils page and dark mode is active
  const isStencilsPage = location.pathname === '/stencils';
  
  return (
    <Fragment>
      {currentUser && (
        <div className={`${isStencilsPage && isDarkModeActive ? 'dark-mode-active' : ''}`}>
          <Sidebar />
          <div className={`${sideBarState ? 'ml-64' : 'ml-16'} ${isStencilsPage && isDarkModeActive ? 'dark-mode-active' : ''}`}>
            <AppBar />
            {children}
          </div>
        </div>
      )}
      {!currentUser && <div className={`${isStencilsPage && isDarkModeActive ? 'dark-mode-active' : ''}`}>{children}</div>}
    </Fragment>
  );
};

export default WrapperComponent;
